import { Outlet } from 'react-router-dom'

const Vessels = () => {
  return <Outlet />
}

export default Vessels
